import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getMainForm, getHomeValForm } from 'store';
import PropDetails from './propDetails';
import PropDetailsWithVal from './propDetailsWithVal';
import MainForm from 'components/maf/form-wizard';
import * as queryString from 'query-string';
import ValuationRange from './valuationRage';
import ValuationGraph from './valuationGraph';
import laptopImage from 'images/homeval/laptop.png';
import screenshotImage from 'images/homeval/screenshot.png';
import Checkmark from 'components/global/checkmark';
import 'styles/global/mrc.scss';

const MRCWidget = ({ intention }) => {
  useEffect(() => {
    window.Fmcty = {
      values: {
        "loan_type": intention === 'Refinancing' ? "R" : "equity",
        "lp_s1": intention === 'Refinancing' ? "refiWidget001" : "homeEquityWidget001"
      }
    };

    // Set up submission callback
    window.submissionReturn = (data) => {
      console.log("Refinance lead submission:", data);
    };

    // Create and load script
    const script = document.createElement('script');
    script.src = 'https://www.mortgageresearchcenter.com/scripts/referralExchangeStandard.js';
    script.setAttribute('data-mrc', 'ReferralExchange');
    script.setAttribute('data-mrc-color', '#1677be');
    script.setAttribute('data-mrc-color-hover', '#326aa6');
    script.setAttribute('data-mrc-supported-loan-types', intention === 'Refinancing' ? 'R' : 'equity');
    script.setAttribute('data-mrc-desc', intention === 'Refinancing' ? 'refinance' : 'home equity');
    script.setAttribute('data-mrc-success-callback', 'submissionReturn');
    script.async = true;

    // Add script to container
    const container = document.getElementById('mrc-widget-container');
    if (container) {
      container.appendChild(script);
    }

    // Cleanup
    return () => {
      const existingScript = document.querySelector('script[src*="mortgageresearchcenter.com"]');
      if (existingScript && container) {
        container.removeChild(existingScript);
      }
      delete window.Fmcty;
      delete window.submissionReturn;
    };
  }, [intention]);

  return (
    <div className="w-full px-5 mx-auto mrc rounded-2xl">
      <div id="mrc-wrapper" className="w-full">
        <div id="mrc-widget-container" className="w-full"></div>
      </div>
    </div>
  );
};

const Found = (props) => {

  const { fields = {} } = useSelector(getMainForm);
  const { fields: homeValFields = {} } = useSelector(getHomeValForm);

  const {
    intention,
    isKVCoreFunnel
  } = fields;

  const { street } = homeValFields;

  const [isStepComplete, setIsStepComplete] = useState(false);

  const checkQueryString = () => {
    const parsed = queryString.parse(window.location.search);
    setIsStepComplete(parsed.step === 'complete');

    if (parsed.step === 'complete') {
      document.getElementById('disclaimer').style.display = 'block';
    } else {
      document.getElementById('disclaimer').style.display = 'none';
    }
  };

  useEffect(() => {
    const originalPushState = window.history.pushState;
    window.history.pushState = function() {
      originalPushState.apply(this, arguments);
      window.dispatchEvent(new Event('pushstate'));
    };

    checkQueryString();

    window.addEventListener('popstate', checkQueryString);
    window.addEventListener('pushstate', checkQueryString);

    return () => {
      window.history.pushState = originalPushState;
      window.removeEventListener('popstate', checkQueryString);
      window.removeEventListener('pushstate', checkQueryString);
    };
  }, []);

  const DetailsComponent = isStepComplete ? PropDetailsWithVal : PropDetails;

  const handleGoBack = () => window.history.back();

  const renderCuriousSection = () => (
    <div id="cta-section" className="flex flex-col justify-end items-center rounded-2xl border-2 border-[#CFD3F9] bg-white">
      <div className="flex px-[24px] py-[32px] flex-col items-center gap-[17px] flex-shrink-0 self-stretch">
        <img className="w-56 h-36" src={laptopImage} alt="Laptop" />
        <div className="flex flex-col gap-[17px] flex-shrink-0">
          <div className="text-center text-[24px] md:text-[31px] font-medium leading-[120%] tracking-[-0.62px] [font-feature-settings:'liga'_off,'clig'_off] text-[var(--Card-Colors-headline-color,#2A2F64)]">
            Want to keep an eye on your home's worth?
          </div>
          <div className="text-center [font-feature-settings:'liga'_off,'clig'_off] text-[var(--Card-Colors-scheme-body-text-color,rgba(55,62,130,0.75))] font-['Poppins'] text-sm font-normal leading-[150%]">
            Lookout for the above email headed to your inbox now.
          </div>
          <img className="mx-auto w-72 h-72" src={screenshotImage} alt="Dashboard Screenshot" />
          <div className="text-[rgba(55,_62,_130,_0.75)] text-center text-[14px] not-italic font-normal leading-[150%]">
            Click the link in the email to access your Personalized Homeowner Dashboard where you can:
          </div>
        </div>
        <div className="flex flex-col gap-2 w-80">
          <div className="flex items-center gap-3">
            <Checkmark />
            <span className="text-sm font-normal leading-tight text-left text-Card-Colors-scheme-body-text-color/75">
              Track your home's real-time value
            </span>
          </div>
          <div className="flex items-center gap-3">
            <Checkmark />
            <span className="text-sm font-normal leading-tight text-left text-Card-Colors-scheme-body-text-color/75">
              See recent market activity near {street}
            </span>
          </div>
          <div className="flex items-center gap-3">
            <Checkmark />
            <span className="text-sm font-normal leading-tight text-left text-Card-Colors-scheme-body-text-color/75">
              Calculate your home equity
            </span>
          </div>
          <div className="flex items-center gap-3">
            <Checkmark />
            <span className="text-sm font-normal leading-tight text-left text-Card-Colors-scheme-body-text-color/75">
              Monitor mortgage rate trends <strong>and more…</strong>
            </span>
          </div>
        </div>
      </div>
    </div>
  );

  const renderRefinanceSection = () => (
    <div id="cta-section" className="flex flex-col justify-end items-center rounded-2xl border-2 border-[#CFD3F9] bg-white">
      <MRCWidget intention="Refinancing" />
    </div>
  );

  const renderHomeEquitySection = () => (
    <div id="cta-section" className="flex flex-col justify-end items-center rounded-2xl border-2 border-[#CFD3F9] bg-white">
      <MRCWidget intention="HomeEquity" />
    </div>
  );

  return (
    <div className="report-wrapper">
      <div className='inner-wrapper'>
        <DetailsComponent {...props} intention={intention} />
        {!isStepComplete && <span className="go-back">Not the right property? <a href="#" onClick={handleGoBack}>Go back</a></span>}
      </div>
      {isStepComplete ? (
        <>
          <div className='inner-wrapper'>
            <div className='valuation-wrapper'>
              <ValuationRange {...props} />
              <ValuationGraph {...props} />
              <div className='about-graph'>
                <h2 className='title'>About This Data</h2>
                <p><strong>Our estimate</strong> is an investor-grade valuation that helps you better estimate the true value of a property. The <strong>Low Range</strong> and <strong>High Range</strong> indicate the confidence interval for our estimate of the subject property.
                Our estimate is not a guarantee of a property's value (see Disclaimers for further details).</p>
              </div>
            </div>
          </div>
          {!isKVCoreFunnel && intention === 'Curious' && renderCuriousSection()}
          {!isKVCoreFunnel && intention === 'Refinancing' && renderRefinanceSection()}
          {!isKVCoreFunnel && intention === 'Home Equity Loan' && renderHomeEquitySection()}
        </>
      ) : (
        <div className='inner-wrapper'>
          <MainForm isHomeVal={true} isLegacyHomeVal={!isKVCoreFunnel} isHomeValFound={true} />
        </div>
      )}
    </div>
  );
};

export default Found;
